import { render, staticRenderFns } from "./supplier-offers.vue?vue&type=template&id=0d9c276e&"
import script from "./supplier-offers.vue?vue&type=script&lang=js&"
export * from "./supplier-offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports